var company = {};
module['exports'] = company;
company.suffix = require("./suffix");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_au_ocker/company/index.js
 ** module id = 567
 ** module chunks = 0
 **/